// extracted by mini-css-extract-plugin
module.exports = {"badge":"ExLeaseBadge_badge__EBeaV","logo":"ExLeaseBadge_logo__AmJ8W","large":"ExLeaseBadge_large__wH4fu"};